module.exports = __webpack_public_path__ + "img/logo.c82d96e3.svg";